import React from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { PlatformContext } from "../components/Platform/PlatformContext";

const DataPrivacy: React.FC = () => {
  let navigate = useNavigate();
  let platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  return (
    <div className="flex flex-col w-screen items-center justify-center">
      <h1 className="text-3xl font-bold text-white mt-10">Datenschutzerklärung</h1>

      <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-lg p-6 m-6 max-w-3xl text-white shadow-lg border border-white/20">
        {/* 1. Datenschutz auf einen Blick */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">
            1. Datenschutz auf einen Blick
          </h2>
          <h3 className="text-xl font-medium mb-2">Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
            besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
            persönlich identifiziert werden können. Ausführliche Informationen
            zum Thema Datenschutz entnehmen Sie unserer unter diesem Text
            aufgeführten Datenschutzerklärung.
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Datenerfassung auf dieser Website
          </h3>
          <p>
            <strong>
              Wer ist verantwortlich für die Datenerfassung auf dieser Website?
            </strong>
          </p>
          <p>
            Die Datenverarbeitung auf dieser Website erfolgt durch den
            Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
            „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung
            entnehmen.
          </p>
          <p>
            <strong>Wie erfassen wir Ihre Daten?</strong>
          </p>
          <p>
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
            mitteilen. Hierbei handelt es sich z. B. um Daten, die Sie bei der
            Registrierung angeben:
          </p>
          <ul className="list-disc pl-5">
            <li>
              <strong>User:</strong> E-Mail-Adresse, Name und Telefonnummer
            </li>
            <li>
              <strong>Teamkapitäne:</strong> zusätzlich Profilbild und Name des
              Vereins
            </li>
          </ul>
          <p className="mt-2">
            Die Angabe von Name und Profilbild ist freiwillig und muss nicht
            Ihre echte Identität widerspiegeln. Andere Daten werden automatisch
            oder nach Ihrer Einwilligung beim Besuch der Website durch unsere
            IT-Systeme erfasst. Das sind vor allem technische Daten (z. B.
            Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
            Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website
            betreten.
          </p>
          <p>
            <strong>Wofür nutzen wir Ihre Daten?</strong>
          </p>
          <p>
            Die personenbezogenen Daten werden ausschließlich verwendet, um:
          </p>
          <ul className="list-disc pl-5">
            <li>Registrierung und Login auf der Website zu ermöglichen,</li>
            <li>
              Kommunikation zwischen Spielern, Kapitänen und Schiedsrichtern
              sicherzustellen,
            </li>
            <li>
              Spiele der Fußballliga zu organisieren, zu planen und
              durchzuführen.
            </li>
          </ul>
          <p className="mt-2">
            Ein Teil der technischen Daten wird erhoben, um eine fehlerfreie
            Bereitstellung der Website zu gewährleisten.
          </p>
          <p>
            <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong>
          </p>
          <p>
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
            Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
            erhalten. Sie haben außerdem ein Recht, die Berichtigung oder
            Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
            Datenverarbeitung erteilt haben, können Sie diese Einwilligung
            jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht,
            unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
            Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Hierzu
            sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich
            jederzeit an uns wenden.
          </p>
        </div>

        {/* 2. Hosting */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">2. Hosting</h2>
          <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
          <p>
            <strong>Hetzner</strong>
          </p>
          <p>
            Anbieter ist die Hetzner Online GmbH, Industriestr. 25, 91710
            Gunzenhausen, Deutschland (nachfolgend Hetzner). Details entnehmen
            Sie der Datenschutzerklärung von Hetzner:{" "}
            <a
              href="https://www.hetzner.com/de/legal/privacy-policy/"
              className="text-blue-300 underline"
            >
              https://www.hetzner.com/de/legal/privacy-policy/
            </a>
            .
          </p>
          <p>Unsere Datenbank wird verwaltet von:</p>
          <p>
            <strong>Supabase</strong>
          </p>
          <p>
            Anbieter ist Supabase Inc., 970 Toa Payoh North #07-04, Singapur,
            mit Servern ausschließlich in der EU. Details finden Sie hier:{" "}
            <a
              href="https://supabase.com/privacy"
              className="text-blue-300 underline"
            >
              https://supabase.com/privacy
            </a>
            .
          </p>
          <p className="mt-2">
            Die Verwendung von Hetzner und Supabase erfolgt auf Grundlage von
            Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an
            einer möglichst zuverlässigen Darstellung und Verwaltung unserer
            Website und Datenbank. Mit beiden Anbietern haben wir Verträge zur
            Auftragsverarbeitung gemäß Art. 28 DSGVO geschlossen.
          </p>
        </div>

        {/* 3. Allgemeine Hinweise und Pflichtinformationen */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">
            3. Allgemeine Hinweise und Pflichtinformationen
          </h2>
          <h3 className="text-xl font-medium mb-2">Datenschutz</h3>
          <p>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
            Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
            vertraulich und entsprechend den gesetzlichen
            Datenschutzvorschriften sowie dieser Datenschutzerklärung. Wenn Sie
            diese Website benutzen, werden verschiedene personenbezogene Daten
            erhoben. Diese Datenschutzerklärung erläutert, welche Daten wir
            erheben und wofür wir sie nutzen.
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Hinweis zur verantwortlichen Stelle
          </h3>
          <p>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser
            Website ist:
          </p>
          <p>
            <strong>Levi Frim</strong>
            <br />
            [Adresse]
            <br />
            [Adresse]
            <br />
            Deutschland
            <br />
            Telefon: 01234 567889
            <br />
            E-Mail: levi@frim.rocks
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">Speicherdauer</h3>
          <p>
            Soweit innerhalb dieser Datenschutzerklärung keine speziellere
            Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
            bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie
            ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung
            zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern
            wir keine anderen rechtlich zulässigen Gründe für die Speicherung
            Ihrer personenbezogenen Daten haben (z. B. steuer- oder
            handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall
            erfolgt die Löschung nach Fortfall dieser Gründe.
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Allgemeine Hinweise zu den Rechtsgrundlagen
          </h3>
          <p>
            Die Verarbeitung Ihrer Daten zur Nutzung der Plattform erfolgt auf
            Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
            Technische Daten werden auf Basis von Art. 6 Abs. 1 lit. f DSGVO
            (berechtigtes Interesse) verarbeitet. Falls eine Einwilligung
            erforderlich ist (z. B. für Cookies), stützen wir uns auf Art. 6
            Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG.
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Empfänger von personenbezogenen Daten
          </h3>
          <p>
            Kontaktdaten von Spielern, Kapitänen und Schiedsrichtern werden nur
            an autorisierte Schiedsrichter und Kapitänen der Liga weitergegeben, soweit dies
            für die Organisation und Durchführung der Spiele erforderlich ist.
            Weitere Empfänger sind unsere Auftragsverarbeiter Hetzner und
            Supabase (siehe Abschnitt 2). Eine Weitergabe an unbefugte Dritte
            erfolgt nicht.
          </p>
        </div>

        {/* 4. Rechte der Betroffenen */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">
            4. Rechte der Betroffenen
          </h2>
          <h3 className="text-xl font-medium mb-2">
            Widerruf Ihrer Einwilligung zur Datenverarbeitung
          </h3>
          <p>
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
            Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
            jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
            erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
            gegen Direktwerbung (Art. 21 DSGVO)
          </h3>
          <p>
            WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E
            ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN,
            DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE
            VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN;
            DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING.
            DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT,
            ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH
            EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT
            MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE
            GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE
            UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER
            GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN
            (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
          </p>
          <p>
            WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU
            BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE
            VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE
            DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING,
            SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE
            WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND
            NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH
            ART. 21 ABS. 2 DSGVO).
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Beschwerderecht bei der zuständigen Aufsichtsbehörde
          </h3>
          <p>
            Im Falle von Verstößen gegen die DSGVO steht Ihnen ein
            Beschwerderecht bei einer Aufsichtsbehörde zu, insbesondere in dem
            Mitgliedstaat Ihres gewöhnlichen Aufenthalts, Ihres Arbeitsplatzes
            oder des Orts des mutmaßlichen Verstoßes. Das Beschwerderecht
            besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
            gerichtlicher Rechtsbehelfe. In Deutschland zuständig: Bayerisches
            Landesamt für Datenschutzaufsicht.
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Recht auf Datenübertragbarkeit
          </h3>
          <p>
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
            oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich
            oder an einen Dritten in einem gängigen, maschinenlesbaren Format
            aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten
            an einen anderen Verantwortlichen verlangen, erfolgt dies nur,
            soweit es technisch machbar ist.
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Auskunft, Berichtigung und Löschung
          </h3>
          <p>
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
            jederzeit das Recht auf unentgeltliche Auskunft über Ihre
            gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger
            und den Zweck der Datenverarbeitung und ggf. ein Recht auf
            Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren
            Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an
            uns wenden.
          </p>
          <h3 className="text-xl font-medium mt-4 mb-2">
            Recht auf Einschränkung der Verarbeitung
          </h3>
          <p>
            Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen. Hierzu können Sie sich
            jederzeit an uns wenden. Das Recht auf Einschränkung der
            Verarbeitung besteht in folgenden Fällen:
          </p>
          <ul className="list-disc pl-5">
            <li>
              Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
              personenbezogenen Daten bestreiten, benötigen wir in der Regel
              Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie
              das Recht, die Einschränkung der Verarbeitung Ihrer
              personenbezogenen Daten zu verlangen.
            </li>
            <li>
              Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig
              geschah/geschieht, können Sie statt der Löschung die Einschränkung
              der Datenverarbeitung verlangen.
            </li>
            <li>
              Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie
              sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von
              Rechtsansprüchen benötigen, haben Sie das Recht, statt der
              Löschung die Einschränkung der Verarbeitung Ihrer
              personenbezogenen Daten zu verlangen.
            </li>
            <li>
              Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt
              haben, muss eine Abwägung zwischen Ihren und unseren Interessen
              vorgenommen werden. Solange noch nicht feststeht, wessen
              Interessen überwiegen, haben Sie das Recht, die Einschränkung der
              Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </li>
          </ul>
          <p className="mt-2">
            Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten
            eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung
            abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung,
            Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der
            Rechte einer anderen natürlichen oder juristischen Person oder aus
            Gründen eines wichtigen öffentlichen Interesses der Europäischen
            Union oder eines Mitgliedstaats verarbeitet werden.
          </p>
        </div>

        {/* 5. Kontakt */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">5. Kontakt</h2>
          <p>
            Für Fragen und Anliegen zum Datenschutz wenden Sie sich bitte an:
          </p>
          <p>
            <strong>Levi Frim</strong>
            <br />
            E-Mail: levi@frim.rocks
          </p>
        </div>
      </div>
    </div>
  );
};

export default DataPrivacy;
